import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 39 39',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="cambio" transform="translate(-968 -624)">
      <circle
        id="Elipse_461"
        data-name="Elipse 461"
        cx="19.5"
        cy="19.5"
        r="19.5"
        transform="translate(968 624)"
        fill={fill}
      />
      <rect
        id="Retângulo_5559"
        data-name="Retângulo 5559"
        width="3"
        height="11"
        rx="1.5"
        transform="translate(978 634)"
        fill="#fff"
      />
      <rect
        id="Retângulo_5560"
        data-name="Retângulo 5560"
        width="3"
        height="19"
        rx="1.5"
        transform="translate(986 634)"
        fill="#fff"
      />
      <rect
        id="Retângulo_5562"
        data-name="Retângulo 5562"
        width="3"
        height="19"
        rx="1.5"
        transform="translate(997 642) rotate(90)"
        fill="#fff"
      />
      <rect
        id="Retângulo_5561"
        data-name="Retângulo 5561"
        width="3"
        height="19"
        rx="1.5"
        transform="translate(994 634)"
        fill="#fff"
      />
    </g>
  </svg>
);

export default SVG;
